module.exports = __webpack_public_path__ + "static/media/11.6792225e.jpg";